import SectionHeader  from "../components/SectionHeader";
import TextWrapper from "./TextWrapper";
import VariantWrapper from "./VariantWrapper";
import { CAROUSEL_ITEM_PADDING } from "../PosterChapter.constants";
import { GradualSpacing } from '../../../effects/GradualSpacing';
import ServiceHubPosterChapterData from '../PosterChapter.interface';
import { LARGE_VARIANT_CONFIG, usePosterTitle } from './usePosterTitle.hook';

export default function LayoutVariant2(props: ServiceHubPosterChapterData) {
    const { subtitle, is_show_date, headline } = props;

    const computedTitleSize = usePosterTitle(headline, LARGE_VARIANT_CONFIG);

    return (
        <VariantWrapper data={props}>
            <TextWrapper style={{ color: 'white' }}>
                <SectionHeader title={subtitle} isShowDate={is_show_date} animated animationOffset={1} />
            </TextWrapper>

            <TextWrapper
                style={{
                    color: 'white',
                    padding: `${CAROUSEL_ITEM_PADDING}vh`,
                    bottom: 0,
                    left: 0,
                    fontSize: `${computedTitleSize.fontSize}vh`,
                    lineHeight: `${computedTitleSize.lineHeight}vh`,
                    textTransform: 'uppercase',
                    fontFamily: 'HelveticaNowDisplay',
                    fontWeight: '500',
                }}
            >
                <GradualSpacing text={headline} offset={1} />
            </TextWrapper>
        </VariantWrapper>
    )
}
